// ============================================================
// CONTACT FAQ — grounded in the company's stated positioning
// (single-partner studio, in-house delivery, dark-minimal design
// system, monitored pipelines). Items marked CONFIRM contain
// commitments you should sanity-check before they go live.
// ============================================================

export const faq = [
  {
    q: "How do engagements work?",
    a: "Most projects run as fixed-scope builds with clearly staged milestones — discovery, design, engineering, then launch with monitoring. For ongoing product work we move to a monthly retainer. Either way you work directly with the people building your product; nothing is outsourced.",
    // CONFIRM: fixed-scope + retainer is the assumed model.
  },
  {
    q: "How long does a typical project take?",
    a: "A focused MVP typically ships in 6–10 weeks; larger platforms run 3–6 months with staged releases. You'll get an honest timeline after discovery — we'd rather commit to less and deliver early than the reverse.",
    // CONFIRM: the 6–10 week / 3–6 month ranges.
  },
  {
    q: "What stack do you build on?",
    a: "React and TypeScript on the frontend, Python (FastAPI) and Node on the backend, MongoDB or PostgreSQL for data, containerised deployments on AWS or GCP, and production-grade LLM integration where it genuinely helps. We choose per project — the stack serves the product, not the other way around.",
  },
  {
    q: "How do we communicate during the build?",
    a: "A shared channel (Slack or your preference), a weekly demo of working software, and a live staging environment you can open at any time. Progress is something you can click, not a status document.",
    // CONFIRM: weekly demo cadence.
  },
  {
    q: "Who owns the code?",
    a: "You do. Full source, infrastructure configuration and documentation are handed over in your own repositories — no lock-in, no licensing games. We keep nothing proprietary inside your product.",
  },
  {
    q: "What happens after launch?",
    a: "Every project ships with monitoring and alerting already wired in. We offer ongoing support and iteration retainers, or a clean handover to your team with documentation and a walkthrough — your call.",
  },
];
